import Linking from "react-native-web/dist/exports/Linking";
import Platform from "react-native-web/dist/exports/Platform";
import PropTypes from 'prop-types';
import { pressPropTypes } from './pressProps';
import a11yProps from './a11yProps';
import hrefAttrsProp from './hrefAttrsProp';
import getPropSelector from './getPropSelector';
const linkPropTypes = {
  ...pressPropTypes,
  href: PropTypes.string,
  hrefAttrs: PropTypes.shape(hrefAttrsProp.types),
  ...a11yProps.types
};
export default {
  /**
   * Proptypes for components that, on Web, can output <a href="..."> link elements
   */
  types: linkPropTypes,
  /**
   * Filters a props object, returning only the platform-relevant link props defined above
   */
  select: getPropSelector(linkPropTypes),
  /**
   * Turn hrefs into press handlers that open links on Native.
   *
   * @param {({ onPress?: () => void, href?: string })}
   * @returns {(() => void)|undefined} Returns a press handler, or undefined on web if no press
   * handler is provided (expects calling component to render as `<a href={href}>` on web).
   */
  handleHref: _ref => {
    let {
      onPress,
      href
    } = _ref;
    return Platform.select({
      web: onPress,
      default: function () {
        if (onPress) onPress(...arguments);
        if (href) Linking.openURL(href);
      }
    });
  }
};